export abstract class Observer<T> {
  abstract update(params: T);
}
